import isEmpty from 'lodash/fp/isEmpty';

export const stringToBool = (s: string) => /true/i.test(s);

export const stringToBoolOrValue = (s: string) =>
  /true/i.test(s) ? true : /false/i.test(s) || isEmpty(s) ? false : s;
